import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { refreshProductList, closeProductModal } from "../../redux/features/productModalSlice";
import { addUser } from "../../redux/services/User Services/User.Services";
import { ActiveCategoryList } from "../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../redux/services/subCategoriesService/subCategories.Services";
import { ModuleList } from "../../redux/services/moduleService/module.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { useDispatch, useSelector } from "react-redux";
function CreateClint({ data, isModal = false }) {
    const dispatch = useDispatch()
    const [errors, setErrors] = useState({});
    const { refreshData } = useSelector(
        (state) => state.staffModal
    );
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    // const [roles, setRoles] = useState([]);
    const [moduleList, setModuleList] = useState([]);
    const [previews, setPreviews] = useState({
        adharfront: null,
        adharback: null,
    });
    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
        // password: "",
        // aadhaar_number: "",
        // category_id: "",
        // gst: "",
        // adharfront: null,
        // pan_number: "",
        // adharback: null,
        // pan_card_image: null,
        // module_id: [],
        business_name: "",
        // subcategory_id: "",
        status: 1,
    });


    // const getDropdownData = async () => {
    //     try {
    //         const catResponse = await ActiveCategoryList();
    //         if (catResponse?.success) {
    //             setCategories(catResponse.data || []);
    //         }
    //         const moduleResponse = await ModuleList();
    //         if (moduleResponse?.success) {
    //             setModuleList(moduleResponse?.data || []);
    //         }
    //         else if (moduleResponse?.data?.success) {
    //             setModuleList(moduleResponse?.data?.data || []);
    //         }
    //         else { setModuleList([]); }
    //     } catch (error) {
    //         console.log("Error fetching dropdown data:", error);
    //         errorToast("Failed to load dropdown data");
    //     }
    // };

    // useEffect(() => {
    //     getDropdownData();
    //     // fetchRoles();
    // }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if ((name === "pan_number" || name === "gst") && value.length > (name === "gst" ? 15 : 10)) return;
        setFormData((prev) => ({
            ...prev,
            [name]: (name === "pan_number" || name === "gst") ? value.toUpperCase() : value
        }));
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: null,
            }));
        }
    };




    // const handleCategoryChange = async (e) => {
    //     const categoryId = e.target.value;
    //     setFormData((prev) => ({
    //         ...prev,
    //         category_id: categoryId,
    //         subcategory_id: "",
    //         module_id: "",
    //     }));
    //     setErrors((prev) => {
    //         const updated = { ...prev };
    //         delete updated.category_id;
    //         delete updated.subcategory_id;
    //         delete updated.module_id;
    //         return updated;
    //     });
    //     // if (errors.category_id) {
    //     //     setErrors((prev) => {
    //     //         const updated = { ...prev };
    //     //         delete updated.category_id;
    //     //         return updated;
    //     //     });
    //     // }
    //     if (categoryId) {
    //         try {
    //             const subResponse = await ActiveSubCategoryList(categoryId);
    //             if (subResponse?.data?.success) {
    //                 setSubCategories(subResponse.data.data || []);
    //             } else if (subResponse?.success) {
    //                 setSubCategories(subResponse.data || []);
    //             } else {
    //                 setSubCategories([]);
    //             }
    //         } catch (error) {
    //             console.log("Error fetching subcategories:", error);
    //             setSubCategories([]);
    //         }
    //     } else {
    //         setSubCategories([]);
    //     }
    // };
    // const handleFileChange = (e) => {
    //     const { name, files } = e.target;
    //     const file = files?.[0] || null;

    //     setFormData((prev) => ({ ...prev, [name]: file }));

    //     if (file) {
    //         setPreviews((prev) => ({
    //             ...prev,
    //             [name]: URL.createObjectURL(file),
    //         }));
    //     } else {
    //         setPreviews((prev) => ({ ...prev, [name]: null }));
    //     }

    //     if (errors[name]) {
    //         setErrors((prev) => {
    //             const updated = { ...prev };
    //             delete updated[name];
    //             return updated;
    //         });
    //     }
    // };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = ["Name is required"];
        }
        if (!formData.email.trim()) {
            newErrors.email = ["Email is required"];
        }
        // if (!formData.password.trim()) {
        //     newErrors.password = ["Password is required"];
        // }
        if (!formData.business_name.trim()) {
            newErrors.business_name = ["Business Name is required"];
        }
        // if (!formData.subcategory_id.trim()) {
        //     newErrors.subcategory_id = ["SubCategory Name is required"];
        // }
        // if (!formData.category_id.trim()) {
        //     newErrors.category_id = ["Category Name is required"];
        // }
        // if (formData.pan_number && formData.pan_number.length !== 10) {
        //     newErrors.pan_number = ["PAN Number must be exactly 10 characters (e.g. ABCDE1234F)"];
        // } else if (formData.pan_number && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan_number)) {
        //     newErrors.pan_number = ["Invalid PAN Number format (e.g. ABCDE1234F)"];
        // }

        // GST Validation
        // if (formData.gst && formData.gst.length !== 15) {
        //     newErrors.gst = ["GST Number must be exactly 15 characters (e.g. 22AAAAA0000A1Z5)"];
        // } else if (formData.gst && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(formData.gst)) {
        //     newErrors.gst = ["Invalid GST Number format (e.g. 22AAAAA0000A1Z5)"];
        // }
        if (!formData.mobile.trim()) {
            newErrors.mobile = ["Mobile is required"];
        }

        setErrors(newErrors);
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setTimeout(() => {
                const firstErrorField = document.querySelector(".is-invalid");
                if (firstErrorField) {
                    firstErrorField.focus();
                    firstErrorField.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
            return;
        }
        try {
            setLoading(true);
            // const payload = {
            //     name: formData.name,
            //     mobile: formData.mobile,
            //     email: formData.email,
            //     password: formData.password,
            //     status: formData.status,
            //     business_name: formData.business_name,
            //     category_id: formData.category_id,
            //     subcategory_id: formData.subcategory_id,
            // };
            const payload = new FormData();
            payload.append("name", formData.name);
            payload.append("mobile", formData.mobile);
            payload.append("email", formData.email);
            payload.append("business_name", formData.business_name);
            // payload.append("category_id", formData.category_id);
            // payload.append("subcategory_id", formData.subcategory_id);

            // payload.append("module_id[]", formData.module_id);

            payload.append("status", formData.status);
            // payload.append("gst", formData.gst);
            // payload.append("gst_number", formData.gst); 

            // Nayi fields jo backend maang raha hai
            // payload.append("aadhaar_number", formData.aadhaar_number);
            // payload.append("pan_number", formData.pan_number);

            // Files append karna
            // if (formData.adharfront) {
            //     payload.append("aadhaar_front", formData.adharfront);
            // }
            // if (formData.adharback) {
            //     payload.append("aadhaar_back", formData.adharback);
            // }
            // if (formData.pan_card_image) {
            //     payload.append("pan_card_image", formData.pan_card_image);
            // }

            const res = await addUser(payload);
            if (res?.success === true) {
                successToast(res?.message || "vendor created successfully");
                refreshProductList()

                if (isModal) {
                    dispatch(closeProductModal());
                } else {
                    navigate("/user-list");
                }
            } else {
                errorToast(res?.message || "Something went wrong");
            }
        } catch (error) {
            console.log(error);
            const resData = error?.response?.data;
            if (resData?.errors && typeof resData.errors === "object") {
                setErrors(resData.errors);
                const allErrors = Object.values(resData.errors).flat().join(", ");
                // errorToast(allErrors);
            } else {
                errorToast(
                    resData?.message ||
                    resData?.errors ||
                    "Failed to create user"
                );
            }
        }

        finally {
            setLoading(false);
        }
    };
    return (
        <div className="main_page">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>Add Vendor</h4>
                        <button
                            className="add-btn"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} className="row g-3">
                        <div className="col-md-6">
                            <label>Name <span className="text-danger">*</span></label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.name ? "is-invalid" : ""}`}
                            />
                            {errors?.name && (
                                <div className="invalid-feedback">
                                    {errors.name[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Email <span className="text-danger">*</span></label>
                            <input
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.email ? "is-invalid" : ""}`}
                            />
                            {errors?.email && (
                                <div className="invalid-feedback">
                                    {errors.email[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Mobile <span className="text-danger">*</span></label>
                            <input
                                name="mobile"
                                value={formData.mobile}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setFormData((prev) => ({
                                        ...prev,
                                        mobile: value,
                                    }));
                                    if (errors.mobile) {
                                        setErrors((prev) => ({
                                            ...prev,
                                            mobile: null,
                                        }));
                                    }
                                }}
                                className={`form-control custumform ${errors?.mobile ? "is-invalid" : ""}`}
                                maxLength={10}
                            />
                            {errors?.mobile && (
                                <div className="invalid-feedback d-block">
                                    {errors.mobile[0]}
                                </div>
                            )}
                        </div>


                        <div className="col-md-6">
                            <label>Business Name <span className="text-danger">*</span></label>
                            <input
                                name="business_name"
                                value={formData.business_name}
                                onChange={handleChange}
                                className={`form-control custumform   ${errors?.business_name ? "is-invalid" : ""}`}
                            />
                            {errors?.business_name && (
                                <div className="invalid-feedback">
                                    {errors.business_name[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Status</label>
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>

                        {/* <div className="col-md-12">
                            <label>Address <span className="text-danger">*</span></label>
                            <textarea
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                rows="3"
                                className={`form-control custumform ${errors?.address ? "is-invalid" : ""}`}
                            />
                            {errors?.address && (
                                <div className="invalid-feedback d-block">
                                    {errors.address[0]}
                                </div>
                            )}
                        </div> */}
                        {/* SUBMIT */}

                        <div className="col-12 text-end">
                            <button
                                type="submit"
                                className="add-btn"
                                disabled={loading}
                            >
                                {loading ? "Creating..." : "Create Vendor"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default CreateClint;